import {FeInputFieldStatus, FeInputFieldStatusVal} from '@modifi/enums'

export const getInputFieldStatus = ({
  verified,
  provided,
}: {
  verified?: boolean
  provided?: boolean
}): FeInputFieldStatusVal | null => {
  if (typeof verified === 'undefined') {
    return null
  }
  if (verified) {
    return FeInputFieldStatus.VERIFIED
  }
  if (provided) {
    return FeInputFieldStatus.COMPLETED
  }
  return FeInputFieldStatus.PENDING
}

export const getCombinedInputFieldStatus = (
  inputFieldStatuses: FeInputFieldStatusVal[]
): FeInputFieldStatusVal | null => {
  if (inputFieldStatuses.length === 0) {
    return null
  }
  if (inputFieldStatuses.includes(FeInputFieldStatus.PENDING)) {
    return FeInputFieldStatus.PENDING
  }
  if (inputFieldStatuses.includes(FeInputFieldStatus.COMPLETED)) {
    return FeInputFieldStatus.COMPLETED
  }
  return FeInputFieldStatus.VERIFIED
}
